import { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';

export function ChipList({ values, onChange, placeholder = 'Add' }: { values: string[]; onChange: (next: string[]) => void; placeholder?: string }) {
  const [draft, setDraft] = useState('');
  function add() {
    const next = draft.trim();
    if (!next || values.includes(next)) return;
    onChange([...values, next]);
    setDraft('');
  }
  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {values.map((item, index) => (
          <span key={`${item}-${index}`} className="inline-flex items-center gap-1 rounded-full border px-3 py-1 text-sm">
            {item}
            <button type="button" aria-label="Remove" onClick={() => onChange(values.filter((_, i) => i !== index))}>×</button>
          </span>
        ))}
        {!values.length ? <span className="text-sm text-gray-400">None yet</span> : null}
      </div>
      <div className="mt-2 flex gap-2">
        <Input className="h-8" placeholder={placeholder} value={draft} onChange={(event) => setDraft(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); add(); } }} />
        <Button size="sm" variant="outline" onClick={add}>Add</Button>
      </div>
    </div>
  );
}
